import {
  BuildingSkyscraperIcon,
  Button,
  FoldersIcon,
  HomeIcon,
  LogoutIcon,
  PlusIcon,
  StarOutlineIcon,
  UserIcon,
} from "@datagame/ui";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useUserContext } from "../../../../contexts/user/UserContext";
import LogoWhite from "../../../../assets/images/logoWhite.png";

import styles from "./AppNavigationItems.module.scss";

type AppNavigationItemsProps = {
  toggleIsOpen?: () => void;
};

export const AppNavigationItems = ({ toggleIsOpen }: AppNavigationItemsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { signOut } = useUserContext();

  const isMobileNav = !!toggleIsOpen;

  const handleClickLink = () => {
    toggleIsOpen && toggleIsOpen();
  };

  const handleLogout = () => {
    signOut();
    handleClickLink();
  };

  const handleCreateProject = () => {
    navigate("/project");
    handleClickLink();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.logoWrapper}>
        <NavLink onClick={handleClickLink} to="/">
          <img alt="DataGame" className={styles.logo} src={LogoWhite} />
        </NavLink>
      </div>
      <div className={styles.linksWrapper}>
        <NavLink onClick={handleClickLink} to="/" className={({ isActive }) => (isActive ? "active" : undefined)}>
          <HomeIcon />
          {t("navigation:dashboard")}
        </NavLink>
        <NavLink
          onClick={handleClickLink}
          to="/library"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          <FoldersIcon />
          {t("navigation:library")}
        </NavLink>
        <NavLink
          onClick={handleClickLink}
          to="/company"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          <BuildingSkyscraperIcon />
          Company
        </NavLink>
        <hr />
        <NavLink
          onClick={handleClickLink}
          to="/profile"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          <UserIcon />
          {t("navigation:profile")}
        </NavLink>
        <NavLink
          onClick={handleClickLink}
          to="/subscription"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          <StarOutlineIcon />
          {t("navigation:subscription")}
        </NavLink>

        {isMobileNav && (
          <>
            <hr />
            <NavLink onClick={handleLogout} to="/login" className={({ isActive }) => (isActive ? "active" : undefined)}>
              <LogoutIcon />
              {t("navigation:logout")}
            </NavLink>
          </>
        )}
      </div>
      <div className={styles.bottomControls}>
        <Button
          iconSide="left"
          icon={<PlusIcon />}
          onClick={handleCreateProject}
          size={isMobileNav ? "medium" : "small"}
          className={styles.addProjectButton}
        >
          {t("navigation:newProject")}
        </Button>
        {!isMobileNav && (
          <div className={styles.linksWrapper}>
            <hr />
            <NavLink onClick={handleLogout} to="/login" className={({ isActive }) => (isActive ? "active" : undefined)}>
              <LogoutIcon />
              {t("navigation:logout")}
            </NavLink>
          </div>
        )}
      </div>
    </div>
  );
};
